/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListPromoLinksOptions, ListPromoLinksResponses } from '../types/ListPromoLinks'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Use reveal=true to copy a saved private URL. Reusable entries show ACTIVE or REVOKED and have no single claimant. Treat URLs as private and do not cache/log them. ADMIN, same-tenant INTEGRATOR, or AFFILIATE_MANAGER explicitly assigned to the owning QR campaign (including across tenants). Grants are checked on every request; tenant filters do not confer access.
 * @summary List promotional links
 * {@link /v1/link_batches/:batch_id/links}
 */
export function listPromoLinks<ThrowOnError extends boolean = true>(
  options: Options<ListPromoLinksOptions, ThrowOnError>,
): Unwrappable<RequestResult<ListPromoLinksResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/link_batches/{batch_id}/links',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListPromoLinksResponses, ThrowOnError>>,
  )
}
